// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Lenders_wrapper__APD8V","title":"Lenders_title__ko9Dt","lendersWrapper":"Lenders_lendersWrapper__e2bzS","logo":"Lenders_logo__tsHWn","hide":"Lenders_hide__1XnqF"};